import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'filterSend',
    pure: false
})
export class FilterSendPipe implements PipeTransform {
    transform(value: any) {
        return value.filter(e => {
            return e.send;
        }).length;
    }
}